import React from "react";
import "./SelectRoomTypeModal.css";

const GameOptionPopup = ({
  isOpen,
  onClose,
  subjectName = "Ashtanga Hridaya",
  entryFee = 25,
  onPlayFriend,
  onPlay,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="gameOptionPopup__overlay" onClick={onClose}>
      <div
        className="gameOptionPopup__modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          type="button"
          className="gameOptionPopup__close"
          onClick={onClose}
          aria-label="Close"
        >
        <i className="bi bi-x"></i>
        </button>

        {/* Game Icon */}
        <div className="gameOptionPopup__iconWrapper">
          <i className="bi bi-controller"></i>
        </div>

        {/* Heading */}
        <h2 className="gameOptionPopup__title">
          Choose an Option
        </h2>

        <p className="gameOptionPopup__subject">
          {subjectName}
        </p>

        {/* Entry Fee */}
        <div className="gameOptionPopup__feeBox">
          <span className="gameOptionPopup__feeLabel">
            Entry Fee
          </span>

          <span className="gameOptionPopup__feeValue">
            {entryFee} Coins
          </span>
        </div>

        {/* Actions */}
        <div className="gameOptionPopup__actions">
          <button
            type="button"
            className="gameOptionPopup__friendButton"
            onClick={onPlayFriend}
          >
            Play with Friend
          </button>

          <button
            type="button"
            className="gameOptionPopup__playButton"
            onClick={onPlay}
          >
            Let's Play
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameOptionPopup;
